/**
 * ScheduleDraft create mutation hook.
 * Design docs -> frontend/src/features/flightSchedule/ScheduleDraft/docs/20_workspace_ux/28_frontend_code_map_and_data_flow.md
 */

import { useMutation, useQueryClient } from "react-query";
import { scheduleDraftQueryKeys } from "./queryKeys";
import { scheduleDraftDataService } from "../services/scheduleDraftDataService";

export function useCreateScheduleDraft(options = {}) {
    const queryClient = useQueryClient();

    return useMutation(
        (payload) => scheduleDraftDataService.createDraft(payload),
        {
            onSuccess: async (...args) => {
                await queryClient.invalidateQueries(scheduleDraftQueryKeys.all);
                if (options.onSuccess) {
                    await options.onSuccess(...args);
                }
            },
            ...options,
        },
    );
}

export default useCreateScheduleDraft;
